import { Vue, Component, Ref, Prop, Emit } from 'vue-property-decorator'
import { initialProceduresModalState, IContentProceduresGrid } from '@/modules/configurationModule/detail/samples/procedures/Procedures.models'

@Component
export default class ProceduresModal extends Vue {
    @Ref() readonly proceduresModal!: any
    @Prop(String) readonly actionTitle!: string
    @Emit()
    update(procedure: IContentProceduresGrid[]): IContentProceduresGrid[] {
        return procedure
    }
    @Emit()
    create(procedure: IContentProceduresGrid) {
        return procedure
    }

    private state: IContentProceduresGrid
    constructor() {
        super()
        this.state = initialProceduresModalState()
    }

    get canUpdateOrCreate(): boolean {
        return Object.keys(this.fields).some((key: any) => {
            return this.fields?.[key]?.dirty
        })
    }

    get modelValidated(): boolean {
        const modelValidated = !!this.state.code && !!this.state.description
        const hasErrors = !!this.errors.count()
        return this.canUpdateOrCreate && !hasErrors && modelValidated
    }

    async show(selectedRow: IContentProceduresGrid): Promise<void> {
        this.state = initialProceduresModalState()
        await this.$validator.reset()
        if (selectedRow) {
            this.state = { ...selectedRow }
        }
        this.proceduresModal.show()
    }

    hide() { this.proceduresModal.hide() }

    actionModal() {
        if (this.state?.id) {
            this.update([this.state])
        } else {
            this.create(this.state)
        }
    }
}
